export default [{"url":"https://kings-code-0.api.invexerp.io","name":"Branch 1","port":"5034","isStore":true,"isHQ":true}]